export default "__VITE_ASSET__DaEB6FfY__"